import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle/ThemeToggle';
import { useTheme } from '../contexts/ThemeContext';

import './Header.css';

const navItemClass =
  'm-2 inline-flex items-center gap-2 rounded-md px-3 py-2 text-base text-[var(--text-secondary)] transition hover:bg-[var(--bg-tertiary)] hover:text-[var(--text-primary)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-gold)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-navbar)]';
const iconClass = 'h-4 w-4 shrink-0';

function NavLinkItem({ icon, children, to, onClick }) {
  return (
    <Link to={to} className={navItemClass} onClick={onClick}>
      {icon && <img className={iconClass} src={icon} alt="" aria-hidden="true" />}
      {children}
    </Link>
  );
}

function NavAnchor({ icon, children, ...props }) {
  return (
    <a className={navItemClass} {...props}>
      {icon && <img className={iconClass} src={icon} alt="" aria-hidden="true" />}
      {children}
    </a>
  );
}

function Header() {
  const [expanded, setExpanded] = useState(false);
  const navRef = useRef(null);
  const { isDark } = useTheme();

  const closeNavbar = () => {
    setExpanded(false);
  };

  useEffect(() => {
    if (!expanded) {
      return undefined;
    }

    const closeOnOutsideClick = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener('pointerdown', closeOnOutsideClick);

    return () => document.removeEventListener('pointerdown', closeOnOutsideClick);
  }, [expanded]);

  return (
    <div className="header">
      <nav ref={navRef} className="fixed left-0 right-0 top-0 z-50 border-b border-[var(--border-color)] bg-[var(--bg-navbar)] shadow-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="flex min-h-[86px] items-center justify-between gap-4">
            <Link to="/" onClick={closeNavbar} className="shrink-0">
              <div className="logo">
                <img src={isDark ? "/profile/firat.png" : "/profile/firat-light.png"} alt="fy" />
              </div>
            </Link>
            <div className={`${expanded ? 'block' : 'hidden'} absolute left-0 right-0 top-full bg-[var(--bg-navbar)] px-4 pb-4 shadow-md xl:static xl:block xl:flex-1 xl:bg-transparent xl:p-0 xl:shadow-none`}>
              <div className="my-2 flex max-h-[500px] flex-col overflow-y-auto xl:my-0 xl:flex-row xl:items-center">
                <NavLinkItem icon="/icons/home.svg" to="/" onClick={closeNavbar}>
                  Home
                </NavLinkItem>
                <NavLinkItem icon="/icons/contact.svg" to="/contact" onClick={closeNavbar}>
                  Contact
                </NavLinkItem>
                <NavLinkItem icon="/icons/cv.svg" to="/detailed-cv" onClick={closeNavbar}>
                  Experience
                </NavLinkItem>
                <NavLinkItem icon="/icons/blog.svg" to="/blog" onClick={closeNavbar}>
                  Blog
                </NavLinkItem>
                <NavLinkItem icon="/icons/research.svg" to="/research" onClick={closeNavbar}>
                  Research
                </NavLinkItem>
                <NavAnchor icon="/icons/linkedin.svg" href="https://www.linkedin.com/in/yasarigno" target="_blank" rel="noopener noreferrer" onClick={closeNavbar}>
                  LinkedIn
                </NavAnchor>
                <NavAnchor icon="/icons/github.svg" href="https://github.com/yasarigno" target="_blank" rel="noopener noreferrer" onClick={closeNavbar}>
                  GitHub
                </NavAnchor>
              </div>
            </div>
            <div className="ml-auto flex items-center gap-2 sm:ml-0">
              <button
                type="button"
                className={`nav-toggle xl:hidden ${expanded ? 'nav-toggle-open' : ''}`}
                aria-controls="navbarScroll"
                aria-expanded={expanded}
                aria-label={expanded ? 'Close navigation' : 'Open navigation'}
                onClick={() => setExpanded((current) => !current)}
              >
                <span className="nav-toggle-line" />
                <span className="nav-toggle-line" />
                <span className="nav-toggle-line" />
              </button>
              <div onClick={closeNavbar}>
                <ThemeToggle />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
